import {uuid} from '@/util';

export default {
  namespaced: true,
  state: {
    deviceId: uuid(),
  },
  getters: {
    deviceId(state) {
      return state.deviceId;
    },
  },
};
